import qs from 'qs';

import axiosInstance from '../protected';

import {getPersonsUrl} from '../api.config';

import {IJSONResponseListPersonDto, IPerson, IPersonPostBody, IPersonSpec} from '../../shared/types/person.types';
import {IPageable} from '../../shared/types/pageable.types';

export const PersonService = {
  async getAll(
    attr: {
      pageable?: IPageable;
      spec?: IPersonSpec;
    } = {},
  ) {
    const res = await axiosInstance.get<IJSONResponseListPersonDto>(getPersonsUrl(), {
      params: {
        ...attr.pageable,
        ...attr.spec,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return res;
  },

  async getById(id: string) {
    const res = await PersonService.findByIDs([id]);

    return {data: res.data[0]};
  },

  async update(data: IPerson) {
    const updated = await axiosInstance.put<IPerson>(getPersonsUrl(), data);

    return updated;
  },

  async delete(id: string) {
    await axiosInstance.delete(getPersonsUrl(`/${id}`));
  },

  async create(data: IPersonPostBody) {
    const updated = await axiosInstance.post<IPerson>(getPersonsUrl(), data);

    return updated;
  },

  async findByIDs(IDs: string[]) {
    const res = await axiosInstance.post<IPerson[]>(getPersonsUrl(`/findByIDs`), IDs);

    return res;
  },
};
